var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.139 0.267686L32.589 8.29242C33.0132 8.50286 33.3699 8.82666 33.6192 9.22745C33.8684 9.62824 34.0003 10.0902 34 10.5613V12.9941C34 14.1598 33.048 15.1058 31.875 15.1058H30.6V28.6212H32.3C32.7509 28.6212 33.1833 28.7992 33.5021 29.116C33.8209 29.4328 34 29.8625 34 30.3106C34 30.7586 33.8209 31.1884 33.5021 31.5052C33.1833 31.822 32.7509 32 32.3 32H1.7C1.24913 32 0.81673 31.822 0.497918 31.5052C0.179107 31.1884 0 30.7586 0 30.3106C0 29.8625 0.179107 29.4328 0.497918 29.116C0.81673 28.7992 1.24913 28.6212 1.7 28.6212H3.4V15.1058H2.125C0.952 15.1058 0 14.1598 0 12.9941V10.5613C0 9.67943 0.459 8.86851 1.2002 8.40899L15.8593 0.267686C16.2135 0.0916494 16.604 0 17 0C17.396 0 17.7848 0.0916494 18.139 0.267686ZM25.5 15.1058H8.5V28.6212H11.9V18.4847H15.3V28.6212H18.7V18.4847H22.1V28.6212H25.5V15.1058ZM17 6.65875C16.5491 6.65875 16.1167 6.83674 15.7979 7.15357C15.4791 7.4704 15.3 7.90011 15.3 8.34817C15.3 8.79623 15.4791 9.22594 15.7979 9.54276C16.1167 9.85959 16.5491 10.0376 17 10.0376C17.4509 10.0376 17.8833 9.85959 18.2021 9.54276C18.5209 9.22594 18.7 8.79623 18.7 8.34817C18.7 7.90011 18.5209 7.4704 18.2021 7.15357C17.8833 6.83674 17.4509 6.65875 17 6.65875Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.77cbc030594f72380cf57280acb40a6c.svg";
export { ForwardRef as ReactComponent };